import { LIST_FEATURE_FLAGS, useFeatureFlag, useFeatureFlagWithState } from '@diamond/shared/utils';

export function useNominalLebihBayarEnabled(): boolean {
  return useFeatureFlag(LIST_FEATURE_FLAGS.FF_NOMINAL_LEBIH_BAYAR, false);
}

export function useNominalLebihBayarEnabledWithState() {
  return useFeatureFlagWithState(LIST_FEATURE_FLAGS.FF_NOMINAL_LEBIH_BAYAR, false);
}
